import {z} from 'zod';
import {StrategySignal} from '../copilotCampaigns.enums';
import {
  audiencesPropertiesSchema,
  contentDataSchema,
  dateAndTimeSchema,
  languageSchema,
  productDataSchema,
  signalsSchema,
  sportsDataSchema,
  storeDataSchema,
  userLocationSchema,
  weatherSchema,
  websitePastEngagementSchema,
} from '../copilotCampaigns.schemas';

function getAvailableSignals(): z.infer<typeof signalsSchema> {
  const audiencesDescription = `Which audience / segment the user belong to.
The audience id can be provided by the placemnet id (placement represents an audience),
placement custom parameter (if multiple placements represents an audience,
from DSP macro (if provided in realtime by the DSP) or
from Audience library (If uploaded in advance to Clinch)`;

  const userLocationDescription = `Use user location signal for decisioning
The user location can be resolved in realtime by Clinch IP-2-Location or
provided from the placement (placement id or placement custom param represents a region such as city/state etc )
For resolving (decisioning) of nearest store location, or nearest store location by zip code, the user location signals must be sourced from Clinch IP-2-Location.
For other decisioning on a city level or bigger areas, the user location can come from the placement.`;

  const languageDescription = `Use user language for ad decisioning
The user language can be resolved from multiple sources such as http header, from placement level,
from user country or user region (country or region represents language)`;

  const websitePastEngagementDescription = `Use user past engagement with the website/app of the advertiser for decisioning
this signal require website-pixels / app-events data source setup on the account.`;

  const dateAndTimeDescription = `Use Date and time as signal for decioning`;

  const weatherDescription = `Use weather information on user location for ad decisioning`;

  const sportsDataDescription = `Use sports data, such as events/teams information and stats as input for further decisioning.
This is not a native input signal. The sports event / team need to be selected in the decision map based on input signals
and then further decisioning can be made according to the sports event or team attributes.`;

  const productDataDescription = `Use product attributes, such as brand,category or price as input for further decisioning.
This is not a native input signal. The product need to be selected in the decision map based on input signals
and then further decisioning can be made according to the product attributes.`;

  const storeDataDescription = `Use store attributes as input for further decisioning.
This is not a native input signal. The store need to be selected in the decision map based on input signals
and then further decisioning can be made according to the store attributes.`;

  const contentDataDescription = `Use store attributes as input for further decisioning.
This is not a native input signal. The store need to be selected in the decision map based on input signals
and then further decisioning can be made according to the store attributes.`;

  const signals = [
    {
      name: StrategySignal.Audiences,
      description: audiencesDescription,
      propertiesSchema: audiencesPropertiesSchema,
    },
    {
      name: StrategySignal.UserLocation,
      description: userLocationDescription,
      propertiesSchema: userLocationSchema,
    },
    {
      name: StrategySignal.Language,
      description: languageDescription,
      propertiesSchema: languageSchema,
    },
    {
      name: StrategySignal.WebsitePastEngagement,
      description: websitePastEngagementDescription,
      propertiesSchema: websitePastEngagementSchema,
    },
    {
      name: StrategySignal.DateAndTime,
      description: dateAndTimeDescription,
      propertiesSchema: dateAndTimeSchema,
    },
    {
      name: StrategySignal.Weather,
      description: weatherDescription,
      propertiesSchema: weatherSchema,
    },
    {
      name: StrategySignal.SportsData,
      description: sportsDataDescription,
      propertiesSchema: sportsDataSchema,
    },
    {
      name: StrategySignal.ProductData,
      description: productDataDescription,
      propertiesSchema: productDataSchema,
    },
    {
      name: StrategySignal.StoreData,
      description: storeDataDescription,
      propertiesSchema: storeDataSchema,
    },
    {
      name: StrategySignal.ContentData,
      description: contentDataDescription,
      propertiesSchema: contentDataSchema,
    },
  ];

  return signals;
}

export default getAvailableSignals;
